<template>
  <div id="settings" uk-height-viewport>
    <Header />
    <div class="uk-flex uk-flex-center">
      <div>
        <br />
        <legend v-show="!currentUser.hasCompletedWebOnboarding" class="uk-legend uk-text-bolder uk-text-left uk-margin-bottom">Entrez vos informations personnelles afin de finaliser votre inscription.</legend>

        <div class="uk-card uk-card-default uk-padding uk-flex uk-flex-center uk-border-rounded">
          <form v-on:submit.prevent="save">
            <fieldset class="uk-fieldset">
              <legend class="uk-legend uk-text-bolder uk-text-left">Vos informations personnelles</legend>

              <br />

              <div uk-grid>
                <div class="uk-width-auto@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Civilité</label>
                  <select class="uk-select uk-border-rounded" v-model="form.gender.value" required>
                    <option value="male">Monsieur</option>
                    <option value="female">Madame</option>
                  </select>
                </div>

                <div class="uk-width-expand@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Nom</label>
                  <input
                    class="uk-input uk-border-rounded"
                    v-bind:class="[form.lastName.hasError ? 'uk-form-danger' : '']"
                    type="text"
                    placeholder="Votre nom"
                    @blur="checkLastName()"
                    v-model="form.lastName.value"
                    autofocus
                    required
                  />
                  <label
                    class="uk-form-label uk-align-left uk-text-danger"
                  >{{form.lastName.errorMessage}}</label>
                </div>

                <div class="uk-width-expand@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Prénom</label>
                  <input
                    class="uk-input uk-border-rounded"
                    v-bind:class="[form.firstName.hasError ? 'uk-form-danger' : '']"
                    type="text"
                    v-model="form.firstName.value"
                    @blur="checkFirstName()"
                    placeholder="Votre prénom"
                    required
                  />
                  <label
                    class="uk-form-label uk-align-left uk-text-danger"
                  >{{form.firstName.errorMessage}}</label>
                </div>
              </div>

              <div uk-grid>
                <div class="uk-width-1-2@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Téléphone</label>
                  <!-- <div class="uk-inline"> -->
                  <!-- <span class="uk-form-icon" uk-icon="icon: receiver"></span> -->
                  <input
                    class="uk-input uk-border-rounded"
                    v-bind:class="[form.phoneNumber.hasError ? 'uk-form-danger' : '']"
                    type="tel"
                    placeholder="0X XX XX XX XX"
                    @blur="isPhoneNumber()"
                    v-model="form.phoneNumber.value"
                    pattern="0.*[0-9]{9}$"
                    required
                  />
                  <label
                    class="uk-form-label uk-align-left uk-text-danger"
                  >{{form.phoneNumber.errorMessage}}</label>
                  <!-- </div> -->
                </div>

                <div class="uk-width-expand@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Adresse e-mail</label>
                  <!-- <div class="uk-inline"> -->
                  <!-- <span class="uk-form-icon" uk-icon="icon: mail"></span> -->
                  <input
                    class="uk-input uk-border-rounded"
                    v-bind:class="[form.email.hasError ? 'uk-form-danger' : '']"
                    type="email"
                    placeholder="votre.adresse@email.com"
                    @blur="isEmail()"
                    v-model="form.email.value"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$"
                    required
                  />
                  <label
                    class="uk-form-label uk-align-left uk-text-danger"
                  >{{form.email.errorMessage}}</label>
                </div>
                <!-- </div> -->
              </div>

              <br />
              <br />
              <hr />
              <br />

              <legend class="uk-legend uk-text-bolder uk-text-left">Votre adresse principale</legend>

              <br />

              <div uk-grid>
                <div class="uk-width-expand@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Adresse</label>
                  <input
                    class="uk-input uk-border-rounded"
                    v-bind:class="[form.address.hasError ? 'uk-form-danger' : '']"
                    type="text"
                    v-model="form.address.value"
                    @blur="checkAddress()"
                    placeholder="Rue, Avenue, Chemin..."
                    required
                  />
                  <label
                    class="uk-form-label uk-align-left uk-text-danger"
                  >{{form.address.errorMessage}}</label>
                </div>
              </div>

              <div uk-grid>
                <div class="uk-width-auto@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Code postal</label>
                  <input
                    class="uk-input uk-border-rounded"
                    v-bind:class="[form.zipCode.hasError ? 'uk-form-danger' : '']"
                    type="text"
                    v-model="form.zipCode.value"
                    placeholder="06250"
                    @blur="isZipCode()"
                    pattern="[0-9]{5}$"
                    required
                  />
                  <label
                    class="uk-form-label uk-align-left uk-text-danger"
                  >{{form.zipCode.errorMessage}}</label>
                </div>

                <div class="uk-width-expand@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Ville</label>
                  <input
                    class="uk-input uk-border-rounded"
                    v-bind:class="[form.city.hasError ? 'uk-form-danger' : '']"
                    type="text"
                    v-model="form.city.value"
                    @blur="checkCity()"
                    placeholder="Mougins"
                    required
                  />
                  <label
                    class="uk-form-label uk-align-left uk-text-danger"
                  >{{form.city.errorMessage}}</label>
                </div>

                <div class="uk-width-expand@m">
                  <label
                    class="uk-form-label uk-align-left uk-text-bold"
                    for="form-stacked-text"
                  >Pays</label>
                  <input
                    class="uk-input uk-border-rounded"
                    v-bind:class="[form.country.hasError ? 'uk-form-danger' : '']"
                    type="text"
                    v-model="form.country.value"
                    @blur="checkCountry()"
                    placeholder="France"
                    required
                  />
                  <label
                    class="uk-form-label uk-align-left uk-text-danger"
                  >{{form.country.errorMessage}}</label>
                </div>
              </div>

              <br />
              <br />

              <div
                v-show="!isLoading"
                class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-right"
              >
                <button
                  class="uk-button uk-button-primary uk-border-rounded"
                >Sauvegarder les modifications</button>
              </div>
              <div
                v-show="!isLoading"
                class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-right"
              >
                <button
                  type="button"
                  class="uk-button uk-button-danger uk-border-rounded"
                  v-on:click="signOut()"
                >Se déconnecter</button>
              </div>
              <br />
              <div
                class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-right"
                uk-spinner
                v-show="isLoading"
              ></div>

              <br />
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import Header from "@/components/Header.vue";
import firebase from "firebase";
import router from "../router";

export default {
  name: "Settings",
  components: {
    Header
  },
  data() {
    return {
      form: {
        firstName: { value: "", hasError: false },
        lastName: { value: "", hasError: false },
        gender: { value: "female", hasError: false },
        phoneNumber: { value: "", hasError: false },
        email: { value: "", hasError: false },
        address: { value: "", hasError: false },
        zipCode: { value: "", hasError: false },
        city: { value: "", hasError: false },
        country: { value: "", hasError: false }
      },
      currentUser: {},
      isLoading: false
    };
  },

  mounted() {
    if (localStorage.getItem("currentUser")) {
      try {
        console.log("A");
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.form.firstName.value = this.currentUser.firstName;
        this.form.lastName.value = this.currentUser.lastName;
        this.form.gender.value = this.currentUser.gender;
        this.form.phoneNumber.value = this.currentUser.phoneNumber;
        this.form.email.value = this.currentUser.email;
        this.form.address.value = this.currentUser.address.address;
        this.form.zipCode.value = this.currentUser.address.zipCode;
        this.form.city.value = this.currentUser.address.city;
        this.form.country.value = this.currentUser.address.country;
      } catch (e) {
        localStorage.removeItem("currentUser");
      }
    }

    firebase.auth().onAuthStateChanged(function(user) {
      if (!user) {
        router.push({ path: "/login" });
      }
    });
  },

  methods: {
    signOut: function() {
      firebase
        .auth()
        .signOut()
        .then(function() {
          localStorage.clear();
        })
        .catch(function(error) {
          console.log(error)
        });
    },

    resetEmail: function() {
      firebase
        .auth()
        .sendPasswordResetEmail(this.emailRecuperation)
        .then(function() {

        })
        .catch(function(error) {
          console.log(error)
        });
    },

    save: function() {
      this.isLoading = true;

      const data = {
        uid: firebase.auth().currentUser.uid,
        firstName: this.form.firstName.value,
        lastName: this.form.lastName.value,
        gender: this.form.gender.value,
        phoneNumber: this.form.phoneNumber.value,
        email: this.form.email.value,
        hasCompletedWebOnboarding : true,
        address: {
          address: this.form.address.value,
          zipCode: this.form.zipCode.value,
          city: this.form.city.value,
          country: this.form.country.value
        }
      };

      firebase
        .firestore()
        .collection("Users")
        .doc(firebase.auth().currentUser.uid)
        .set(data, { merge: true })
        .then(() => {
          this.isLoading = false;
          const parsed = JSON.stringify(data);
          localStorage.setItem("currentUser", parsed);
          this.updateProfile();
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },

    updateProfile: function() {
      const user = firebase.auth().currentUser;
      user
        .updateProfile({
          displayName:
            this.form.firstName.value + ' ' + this.form.lastName.value,
          photoURL: ''
        })
        .then(function() {})
        .catch(function(error) {
          console.log(error)
        });

      user
        .updateEmail(this.form.email.value)
        .then(function() {})
        .catch(function(error) {
          console.log(error)
        });
    },

    isEmail: function() {
      var regex = RegExp("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$");
      this.form.email.value = this.form.email.value.trim();
      this.form.email.hasError = !regex.test(this.form.email.value);
      if (this.form.email.hasError) {
        this.form.email.errorMessage =
          "Votre adresse email n'est pas au bon format.";
      } else {
        this.form.email.errorMessage = "";
      }
    },

    isPhoneNumber: function() {
      var regex = RegExp("0.*[0-9]{9}$");
      this.form.phoneNumber.value = this.form.phoneNumber.value.trim();
      this.form.phoneNumber.hasError = !regex.test(this.form.phoneNumber.value);
      if (this.form.phoneNumber.hasError) {
        this.form.phoneNumber.errorMessage =
          "Doit commencer par 0 et comporter 10 chiffres.";
      } else {
        this.form.phoneNumber.errorMessage = "";
      }
    },

    isZipCode: function() {
      var regex = RegExp("[0-9]{5}$");
      this.form.zipCode.value = this.form.zipCode.value.trim();
      this.form.zipCode.hasError = !regex.test(this.form.zipCode.value);
      if (this.form.zipCode.hasError) {
        this.form.zipCode.errorMessage = "Doit comporter 5 chiffres.";
      } else {
        this.form.zipCode.errorMessage = "";
      }
    },

    checkFirstName: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.firstName.value = this.form.firstName.value.trim();
      this.form.firstName.hasError = !regex.test(this.form.firstName.value);
      if (this.form.firstName.hasError) {
        this.form.firstName.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.firstName.errorMessage = "";
      }
    },

    checkLastName: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.lastName.value = this.form.lastName.value.trim();
      this.form.lastName.hasError = !regex.test(this.form.lastName.value);
      if (this.form.lastName.hasError) {
        this.form.lastName.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.lastName.errorMessage = "";
      }
    },

    checkAddress: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.address.value = this.form.address.value.trim();
      this.form.address.hasError = !regex.test(this.form.address.value);
      if (this.form.address.hasError) {
        this.form.address.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.address.errorMessage = "";
      }
    },

    checkCity: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.city.value = this.form.city.value.trim();
      this.form.city.hasError = !regex.test(this.form.city.value);
      if (this.form.city.hasError) {
        this.form.city.errorMessage = "Doit contenir au moins deux caractères";
      } else {
        this.form.city.errorMessage = "";
      }
    },

    checkCountry: function() {
      var regex = RegExp("[a-zA-Z0-9._%+-]{2,}");
      this.form.country.value = this.form.country.value.trim();
      this.form.country.hasError = !regex.test(this.form.country.value);
      if (this.form.country.hasError) {
        this.form.country.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.country.errorMessage = "";
      }
    },

    isSamePassword: function() {},

    displayErrorMessage: function() {
      UIkit.notification(
        "<span uk-icon='icon: warning'></span> Adresse email et/ou mot de passe incorrect.",
        { pos: "bottom-center", status: "danger" }
      );
    }
  }
};
</script>